"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;








































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      deviceTypeList: [], searchData: { nickName: '', mobile: '', email: '', sn: '', deviceTypeCode: '', time: [(0, _formatter.simpleFormatter)(new Date() - 3600 * 1000 * 24 * 29), ''], page: 1, // 当前页码
        rows: 10 // 页码条
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'sn', label: '序列号', isShow: true }, { prop: 'deviceTypeName', label: '型号', isShow: true }, { prop: 'bloodoxygen', label: '血氧值', formatter: _formatter.bloodoxygenPulseRateFormatter, isShow: true }, { prop: 'pulseRate', label: '脉率', formatter: _formatter.bloodoxygenPulseRateFormatter, isShow: true }, { prop: 'shoulderIn', label: '肩内', formatter: _formatter.nwbsssFormatter, isShow: false }, { prop: 'shoulderOut', label: '肩外', formatter: _formatter.nwbsssFormatter, isShow: false }, { prop: 'shoulderBlade', label: '肩胛骨', formatter: _formatter.nwbsssFormatter, isShow: false }, { prop: 'back', label: '背部', formatter: _formatter.nwbsssFormatter, isShow: false }, { prop: 'waist', label: '腰部', formatter: _formatter.nwbsssFormatter, isShow: false }, { prop: 'neck', label: '颈部', formatter: _formatter.nwbsssFormatter, isShow: false }, { prop: 'tigueIndex', label: '疲劳', formatter: _formatter.tigueIndexFormatter, isShow: true }, { prop: 'acheIndex', label: '酸痛程度', formatter: _formatter.acheIndexFormatter, isShow: true }, { prop: 'nickName', label: '用户昵称', isShow: true }, { prop: 'mobile', label: '手机号', isShow: true }, { prop: 'email', label: '邮箱', isShow: true },
      {
        prop: 'eventTime',
        label: '检测时间',
        formatter: _formatter.dateFormatter,
        isShow: true }] };



  },
  mounted: function mounted() {
    var self = this;
    self.init();
    self.getDeviceTypeList();
  },
  methods: {
    init: function init() {
      var self = this;
      var params = Object.assign({}, self.searchData);
      if (params.time) {
        params.startTime = params.time[0] + ' 00:00:00';
        params.endTime = params.time[1] ? params.time[1] + ' 23:59:59' : '';
      }
      delete params['time'];
      self.getData('/api/achePage', params, function (res) {
        console.log("res", res);
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.nickName = '';
      this.searchData.mobile = '';
      this.searchData.email = '';
      this.searchData.sn = '';
      this.searchData.deviceTypeCode = '';
      this.searchData.time = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },

    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    getDeviceTypeList: function getDeviceTypeList() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.deviceTypeList = res;
      });
    },
    excelFun: function excelFun() {
      var self = this;
      var day_30 = 3600 * 30 * 24 * 1000;
      // 校验时间是否填写
      var params = Object.assign({}, self.searchData);
      if (params.time === '') {
        self.$message({
          message: '请选择时间',
          type: 'error' });

        return;
      }
      var start = new Date(params.time[0]);
      var deliverTimeStart = start.getTime();
      var end = params.time[1] ? new Date(params.time[1]) : new Date();
      var deliverTimeEnd = end.getTime();
      console.log('minus=====>', deliverTimeEnd - deliverTimeStart, day_30);
      if (deliverTimeEnd - deliverTimeStart > day_30) {
        self.$message({
          message: '只能导出小于等于30天的的时间',
          type: 'error' });

        return;
      }
      params.startTime = params.time[0] + ' 00:00:00';
      params.endTime = params.time[1] ? params.time[1] + ' 23:59:59' : '';
      delete params['time'];
      self.getData('/api/achePage/export/check', params, function (res) {
        if (res == null) {
          window.location.href = '/api/achePage/export/down?startTime=' +
          params.startTime + '&endTime=' + params.endTime + '&deviceTypeCode=' +
          params.deviceTypeCode + '&email=' + params.email + '&mobile=' +
          params.mobile + '&sn=' + params.sn + '&nickName=' + params.nickName;
        }
      });
    } } };exports.default = _default;